import * as displayWidgets from "./display/definitions";
import * as inputWidgets from "./input/definitions";
export const dashboardWidgets = {
    ...displayWidgets,
    ...inputWidgets,
};
